class TextHero {
	constructor( block ) {
		this.textHero = block;

		// INTRO ANIMATION
		let introSlideLogo = this.textHero.querySelector(".block-text-hero__logo");
		if (introSlideLogo !== null) {
			gsap.to(introSlideLogo, {duration: 1, autoAlpha: 1, scale: 1, delay: 0.5});
		}

		let wrapDelay = 0.5;

		if (introSlideLogo !== null) {
			wrapDelay = 1.5;
		}


		let introSlideWrap = this.textHero.querySelector(".block-text-hero__wrap");
		if (introSlideWrap !== null) {
			gsap.to(introSlideWrap, {duration: 0.5, height: "auto", delay: wrapDelay, ease: " power4. inOut inOut"});
		}

		let headingDelay = 0.5;

		if (introSlideLogo !== null) {
			headingDelay = 1.5;
		}

		let introSlideText = this.textHero.querySelector(".block-text-hero__heading");
		if (introSlideText !== null) {

			gsap.to(introSlideText, {duration: 2, autoAlpha: 1, delay: headingDelay});

			if (introSlideLogo !== null) {
			// Openingtag & closingtag has to be a string!!
				function splitLines(container, openingtag, closingtag) {

					// Get the spans in the paragraph
					var spans = container.children,
						top = 0,
						tmp = '';

					container.innerHTML = container.textContent.replace(/\S+/g, '<n>$&</n>');


					for (let i = 0; i < spans.length; i++) {

						var rect = spans[i].getBoundingClientRect().top;

						if (top < rect) tmp += closingtag + openingtag;
						top = rect;
						tmp += spans[i].textContent + ' ';
					}

					container.innerHTML = tmp += closingtag;
				}
				splitLines(introSlideText, '<span class="block-text-hero__heading-line">', '</span>');

				let headingLines = this.textHero.querySelectorAll(".block-text-hero__heading-line");

				let i = 0;

				headingLines.forEach((line) => {
					i++;
					gsap.to(line, {duration: 2, y: 0, autoAlpha: 1, delay: 1.5 + (i * 1)});
				});

			}

		}


		let descDelay = 1.5;

		let introSlideIntroduction = this.textHero.querySelector(".block-text-hero__introduction");
		if (introSlideIntroduction !== null) {
			gsap.to(introSlideIntroduction, {duration: 1, autoAlpha: 1, y: 0, delay: descDelay});
		}

		if (introSlideLogo !== null) {

			let headingLines = this.textHero.querySelectorAll(".block-text-hero__heading-line");
			let headingLinesCount = headingLines.length;
			descDelay = 1.7 * headingLinesCount;
		}

		let introSlideDescription = this.textHero.querySelector(".block-text-hero__description");
		if (introSlideDescription !== null) {
			gsap.to(introSlideDescription, {duration: 1, autoAlpha: 1, y: 0, delay: descDelay});
		}

		let introSlideTrigger = this.textHero.querySelector(".block-text-hero__arrows");
		if (introSlideTrigger !== null) {
			gsap.to(introSlideTrigger, {duration: 1, autoAlpha: 1, delay: 2});
		}

	}
}

export default TextHero;
